const FromArrEditor = [
  {
    title: "产品线：",
    inputtype: "select",
    modelvalue: '',
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "",
    placeholder: "请选择",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 45,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    event: 'invClassChange'
  },
  {
    title: "订货经销商：",
    modelvalue: '',
    inputtype: "selectSingle",
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 45,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500,
    remoteMethod: 'OrderingDealer',
    loading: false,
    options: [],
  },
  {
    title: "授权经销商：",
    // inputtype: "input",
    inputtype: "selectSingle",
    modelvalue: '',
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 190,
    height: 32,
    disabled: false,
    marginLeft: 25,
    marginTop: 5,
    displayVal: "inline-block",
    fontWeightVal: 500,
    options: [],
    loading: false,
    remoteMethod: 'AuthorizedDealer'
  },
  {
    title: "备注：",
    inputtype: "input",
    modelvalue: '',
    inputflag: true,
    fontSize: 14,
    color: "#333333",
    lableheight: 20,
    X: false,
    types: "text",
    placeholder: "请输入",
    width: 810,
    height: 32,
    disabled: false,
    marginLeft: 45,
    marginTop: 15,
    displayVal: "inline-block",
    fontWeightVal: 500,
  },
];
export default FromArrEditor;
